import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { useIntl } from "react-intl";

export function TitleCell(props) {
  let formattedContent;

  try {
    const intl = useIntl();
    formattedContent = intl.formatMessage({
      id: parse(props.text),
      defaultMessage: parse(props.text),
      description: "",
    });
  } catch (error) {
    formattedContent = parse(props.text);
  }

  return (
    <th className={props.className} colspan={props.colspan}>
      <div className={`dataTable_row_title_contents`}>
        <p>{formattedContent}</p>
      </div>
    </th>
  );
}

TitleCell.propTypes = {
  /**
   * Text to be displayed on the cell
   */
  text: PropTypes.string,
  /**
   * className to be set on the cell
   */
  className: PropTypes.string,
};
